import React, { useCallback, useEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';

import { Feedback } from '../../../Interface/ValidatorFeedback';
import FeedbackForm from '../../General/FeedbackForm';
import { modalRequested } from '../../../Store/Modal/action';
import { postInterestFeedback } from '../../../Service/FeedbackService';

import { useDispatch } from 'react-redux';
import useGetModal from '../../../Hook/UseGetModal';

interface State {
    error: boolean;
    showModal: boolean;
    submitted: boolean;
}

const INITIAL_STATE = { error: false, showModal: false, submitted: false };

const FeedbackButton: React.FC = () => {
    const dispatch = useDispatch();
    const { content } = useGetModal();
    const [{ error, showModal, submitted }, setState] = useState<State>(INITIAL_STATE);

    const submitFeedbackForm = useCallback((feedback: Feedback) => {
        postInterestFeedback(feedback).then(
            () => setState({ error: false, showModal: true, submitted: true }),
            () => setState({ error: true, showModal: true, submitted: false }),
        );
    }, []);

    useEffect(() => {
        if (null === content) setState(INITIAL_STATE);
    }, [content]);

    useEffect((): void => {
        if (showModal) {
            const button = !submitted ? (
                <Button variant="primary" type="submit" form="feedback-form">
                    Verzenden
                </Button>
            ) : null;
            const feedbackForm = (
                <FeedbackForm error={error} submitFeedbackForm={submitFeedbackForm} submitted={submitted} />
            );
            dispatch(modalRequested(button, feedbackForm, 'Feedback'));
        }
    }, [error, showModal, submitted, dispatch, submitFeedbackForm]);

    return (
        <div className="feedback">
            <a
                onClick={() => setState({ error: false, showModal: true, submitted: false })}
                onKeyDown={() => setState({ error: false, showModal: true, submitted: false })}
            >
                Geef feedback
            </a>
        </div>
    );
};

export default FeedbackButton;
